import { createResponseControlMessage } from "../utils/cmsgBuilder";
import { createResponseControlMessageWithoutParams } from "../utils/cmsgBuilder";
import { MyRequest } from "../models/MyRequest";
import Wrapper from "../utils/msrpWrapper";
import Global from "../globals/globals";
import { toast, ToastContainer, ToastOptions } from 'react-toastify';
import obtainSessionkey from "../MSRP/utilities/obtainSessionKey";

/**
 * When the user receives a request, the request is added to the request list.
 * The user can then accept or reject the request.
 * When the user accepts the request, the request is removed from the request list.
 * When the user rejects the request, the request is removed from the request list.
 * When accept/reject we will send a  message to the other user.
 * When the user accepts the request, the user is added to the room.
*/
class RequestController {
  Requests: MyRequest[];
  ServerRequests: MyRequest[];
  unreadRequestsCount: number;
  unreadNotificationsCount: number;
  wrapper: Wrapper;
  addRoom: Function;
  handleAddParticipant:Function;
  toast: (message: string, options?: ToastOptions) => void;

  constructor(wrapper: Wrapper, addRoom: Function,handleAddParticipant:Function,toast: (message: string, options?: ToastOptions) => void) {
    this.Requests = [];
    this.ServerRequests = [];
    this.unreadRequestsCount = 0;
    this.unreadNotificationsCount = 0;
    this.wrapper = wrapper;
    this.addRoom = addRoom;
    this.toast = toast;
    this.handleAddParticipant=handleAddParticipant;

    if (typeof window !== "undefined") {
      const savedRequests = localStorage.getItem("requests");
      const savedServerRequests = localStorage.getItem("Serverrequests");
      if (savedRequests) {
        this.Requests = JSON.parse(savedRequests);
        console.log("Previous requests loaded successfully:", this.Requests);
        //this.toast("Previous requests loaded successfully", { type: "info" });
      }
      if (savedServerRequests) {
        this.ServerRequests = JSON.parse(savedServerRequests);
        //this.toast("Previous server requests loaded successfully", { type: "info" });
        console.log("Previous server requests loaded successfully:", this.ServerRequests);
      }
    }
  }

  addRequest(newRequest: MyRequest): void {
    this.Requests.push(newRequest);
    this.saveRequestsToLocalStorage();
    if (newRequest.incoming && newRequest.status === "pending") {
      this.unreadRequestsCount++;
    } else {
      const receiverStr = Array.isArray(newRequest.receiver) ? newRequest.receiver[0] : newRequest.receiver;
      this.toast(`Request sent to ${receiverStr.split("@")[0]}`, { type: "success" });
    }
    console.log("request list: " + this.Requests);
  }

  // handleRequestResult(requestId: string, status_code: number, status_text: string): void {
  //   console.log("in handle request result:", requestId, status_code, status_text);
  //   console.log("status textt", status_text);

  //   if (status_code === 200 && status_text === "OK") {
  //     this.toast("Request is accepted.", { type: "success" });
  //     // Handle related functions in here 
  //     const request = this.getRequestDetails(requestId);
  //     if (request) {
  //       this.updateRequestStatusById(requestId, "approved");
  //       this.removeRequestById(requestId);
  //       this.addRoom(this.getRequestReceiver(requestId), [], requestId, "active", request.type);
  //       this.saveRequestsToLocalStorage();
  //       this.toast("Room created and joined successfully", { type: "success" });
  //     } else {
  //       console.log("Request with ID " + requestId + " not found.");
  //       this.updateRequestStatusById(requestId, "error");
  //       this.saveRequestsToLocalStorage();
  //  //TODO : specify the error type according to params note  messageParams.details
  //     }
  //   } else {
  //     // Other status codes are: 400, 401, 402
  //     console.log("here")
  //     this.removeRequestById(requestId);
  //     this.toast(status_text, { type: "error" });
  //   }
  // }

  saveRequestsToLocalStorage() {
    console.log("Saving requests to localStorage:", this.Requests);
    if (typeof window !== "undefined") {
      // Ensure we're in the browser context before accessing localStorage
      localStorage.setItem("requests", JSON.stringify(this.Requests));
      const event = new Event("requestsUpdated");
      window.dispatchEvent(event);
      // this.toast("Requests saved successfully", { 
      //   type: "success", 
      //   autoClose: 2000,
      //   position: "bottom-right"
      // });
      console.log("Requests saved successfully to localStorage");
    } else {
      // this.toast("Failed to save requests - browser storage unavailable", { type: "error" });
      console.error("Failed to save requests - browser storage unavailable");
    }
  }

  removeRequestById(requestId: string): void {
    const request = this.Requests.find((r) => r.id === requestId);
    if (request) {
      if (request.incoming && request.status === "pending") {
        this.unreadRequestsCount--;
      }
      this.Requests = this.Requests.filter((r) => r.id !== requestId);
      this.saveRequestsToLocalStorage();
      // this.toast(`Request from ${request.sender.split("@")[0]} removed`, { 
      //   type: "info",
      //   autoClose: 3000
      // });
    } else {
      // this.toast("Request not found for removal", { type: "warning" });
    }
  }

  getRequestDetails(requestId: string): any | null {
    const request = this.Requests.find((r) => r.id === requestId);
    if (!request) {
      // this.toast("Request details not found", { type: "warning" });
    }
    return request ? request.detail : null;
  }

  getRequestReceiver(requestId: string): string | null {
    const request = this.Requests.find((r) => r.id === requestId);
    if (!request) {
      // this.toast("Request receiver not found", { type: "warning" });
    }
    return request ? request.receiver[0] : null;
  }

  acceptRequest(request: MyRequest): void {
    this.updateRequestStatusById(request.id, "approved");
    
    if (request.type === "agent-to-agent") {
      console.log("request id is : " + request.id);
      this.wrapper.sendMsg(
        createResponseControlMessageWithoutParams(
          request.id,
          "request",
          request.type,
          200,
          "OK"
        ),
        "application/rechat.cntl+json"
      );
      const id = "a2a:" + obtainSessionkey(request.sender, Global.username + Global.companyDomain);
      this.toast(`Agent-to-agent request from ${request.sender.split("@")[0]} accepted`, { type: "success" });
      this.addRoom(id, [], id, "active", "agent-to-agent");
    } else if (request.type === "invite-member") {
      this.wrapper.sendMsg(
        createResponseControlMessage(
          request.id,
          "request",
          request.type,
          200,
          "OK",
          `member : ${Global.username + Global.companyDomain}`
        ),
        "application/rechat.cntl+json"
      );
      const participants: string[] = [request.sender,Global.username+Global.companyDomain];
      console.log("confName is : " + request.receiver);
      this.addRoom(request.receiver, participants, request.receiver, "active", "conference");      
    } else if (request.type === "join-chat") {
      this.wrapper.sendMsg(
        createResponseControlMessageWithoutParams(
          request.id,
          "request",
          request.type,
          200,
          "OK"
        ),
        "application/rechat.cntl+json"
      );
      this.wrapper.controller.addParticipant(request.detail, request.sender);
      this.handleAddParticipant(request.receiver,request.sender);
    }

    if (request.status === "pending") {
      this.unreadRequestsCount--;
    }
    this.updateRequestStatusById(request.id, "approved");
  }

  rejectRequest(request: MyRequest): void {
    // Update the request status in the controller
    this.updateRequestStatusById(request.id, "rejected");

    if (request.type === "invite-member") {
      this.wrapper.sendMsg(
        createResponseControlMessage(
          request.id,
          "request",
          request.type,
          400,
          "BUSY",
          `member:${Global.username + Global.companyDomain}`
        ),
        "application/rechat.cntl+json"
      );
      this.toast(`Member invitation from ${request.sender.split("@")[0]} rejected`, { type: "info" });
      
    } else if (request.type === "join-chat") {
      this.wrapper.sendMsg(
        createResponseControlMessageWithoutParams(
          request.id,
          "request",
          request.type,
          400,
          "BUSY"
        ),
        "application/rechat.cntl+json"
      );
      this.toast(`Chat join request from ${request.sender.split("@")[0]} rejected`, { type: "info" });
      
    } else if (request.type === "agent-to-agent") {
      console.log("request id is : " + request.id);
      this.wrapper.sendMsg(
        createResponseControlMessageWithoutParams(
          request.id,
          "request",
          request.type,
          400,
          "BUSY"
        ),
        "application/rechat.cntl+json"
      );
      this.toast(`Agent-to-agent request from ${request.sender.split("@")[0]} rejected`, { type: "info" });
    }

    if (request.status === "pending") {
      this.unreadRequestsCount--;
    }
    this.updateRequestStatusById(request.id, "rejected");
    this.saveRequestsToLocalStorage(); // Save updated requests
  }

  updateRequestStatusByReceiver(receiver: string, newStatus: string): void {
    const index = this.Requests.findIndex((r) => r.receiver === receiver);
    if (index !== -1 && this.Requests[index].status === "pending") {
      this.unreadRequestsCount--;
      this.Requests[index].status = newStatus;
      this.saveRequestsToLocalStorage();
      this.toast(`Request to ${receiver.split("@")[0]} status updated to ${newStatus}`, { 
        type: newStatus === "approved" ? "success" : newStatus === "rejected" ? "warning" : "info" 
      });
    } else {
      this.toast(`Request to ${receiver.split("@")[0]} not found or already processed`, { type: "warning" });
    }
  }

  updateRequestStatusById(requestId: string, newStatus: string): void {
    const index = this.Requests.findIndex((r) => r.id === requestId);
    if (index !== -1 && this.Requests[index].status === "pending") {
      this.unreadRequestsCount--;
      this.Requests[index].status = newStatus;
      console.log("going to update he status", newStatus)
      this.saveRequestsToLocalStorage();
      // this.toast(`Request status updated to ${newStatus}`, { 
      //   type: newStatus === "approved" ? "success" : newStatus === "rejected" ? "warning" : "info",
      //   autoClose: 3000
      // });
    } else if (index === -1) {
      // this.toast("Request not found for status update", { type: "error" });
    }
  }

  findRequestById(requestId: string): MyRequest | null {
    const savedRequests = localStorage.getItem("requests");
    if (savedRequests) {
      this.Requests = JSON.parse(savedRequests);
    }
    console.log("Current Requests:", this.Requests);
    console.log("Looking for request with ID:", requestId);

    const request = this.Requests.find((r) => r.id === requestId);
    if (request) {
      console.log("request found", request);
      // this.toast("Request found and retrieved", { 
      //   type: "success", 
      //   autoClose: 2000,
      //   position: "bottom-right"
      // });
      return request;
    } else {
      console.log("request not found");
      // this.toast(`Request with ID ${requestId} not found`, { type: "warning" });
      return null;
    }
  }

  //server requests functions-----------------------------------------------

  saveServerRequestsToLocalStorage() {
    console.log("Saving Serverrequests to localStorage:", this.ServerRequests);
    if (typeof window !== "undefined") {
      localStorage.setItem("Serverrequests", JSON.stringify(this.ServerRequests));
      const event = new Event("Server requests Updated");
      console.log("Server requests saved successfully to localStorage", event);
      window.dispatchEvent(event);
      // this.toast("Server requests saved successfully", { 
      //   type: "success", 
      //   autoClose: 2000,
      //   position: "bottom-right"
      // });
    } else {
      // this.toast("Failed to save server requests - browser storage unavailable", { type: "error" });
    }
  }

  addServerRequest(newRequest: MyRequest): void {
    this.ServerRequests.push(newRequest);
    this.saveServerRequestsToLocalStorage();
    console.log("server request list: " + this.ServerRequests);
    // this.toast(`New server request added from ${newRequest.sender.split("@")[0]}`, { 
    //   type: "info",
    //   autoClose: 4000
    // });
  }

  removeServerRequestById(requestId: string): void {
    const request = this.ServerRequests.find((r) => r.id === requestId);
    if (request) {
      this.ServerRequests = this.ServerRequests.filter((r) => r.id !== requestId);
      this.saveServerRequestsToLocalStorage();
      // this.toast(`Server request from ${request.sender.split("@")[0]} removed`, { 
      //   type: "info",
      //   autoClose: 3000
      // });
    } else {
      // this.toast("Server request not found for removal", { type: "warning" });
    }
  }

  findServerRequestById(requestId: string): MyRequest | null {
    const savedServerRequests = localStorage.getItem("Serverrequests");
    if (savedServerRequests) {
      this.ServerRequests = JSON.parse(savedServerRequests);
    }
    console.log("Retrieved ServerRequests from localStorage:", savedServerRequests);
    console.log("Current ServerRequests:", this.ServerRequests);
    console.log("Looking for request with ID:", requestId);

    const request = this.ServerRequests.find((r) => r.id === requestId);
    if (request) {
      console.log("request found", request);
      // this.toast("Server request found and retrieved", { 
      //   type: "success", 
      //   autoClose: 2000,
      //   position: "bottom-right"
      // });
      return request;
    } else {
      console.log("request not found");
      // this.toast(`Server request with ID ${requestId} not found`, { type: "warning" });
      return null;
    }
  }
}

export default RequestController;